import React from 'react'
import ReactTooltip from 'react-tooltip'
import { Box, Typography } from '@material-ui/core'
import FieldFile from 'src/components/PostGraduationContent/PostGraduationDetails/Subscribe/Forms/FieldFile/FieldFile'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './SubscriptionFormFields.styles'

const SendFileForm = () => {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  return (
    <>
      <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
        Documentação
      </Typography>
      <Typography className={classes.paragraph}>
        Anexe nos campos abaixo os documentos solicitados.
      </Typography>
      <FieldFile name="FileDocPhoto" required>
        <Typography
          component="label"
          htmlFor="FileDocPhoto"
          className={classes.label}
        >
          Documento com foto *
        </Typography>
        <Box
          component="span"
          className={classes.help}
          data-tip="Anexe um documento de <br /> identificação oficial com foto"
        >
          ?
        </Box>
      </FieldFile>
      <FieldFile name="FileDocSIGAA">
        <Typography
          component="label"
          htmlFor="FileDocSIGAA"
          className={classes.label}
        >
          Comprovante de inscrição gerado e emitido pelo SIGAA
        </Typography>
        <Box
          component="span"
          className={classes.help}
          data-tip="Anexe o documento de inscrição <br /> gerado e emitido pelo SIGAA <br /> no ato da inscrição online"
        >
          ?
        </Box>
      </FieldFile>
      <FieldFile name="FileDocCommitment" required>
        <Typography
          component="label"
          htmlFor="FileDocCommitment"
          className={classes.label}
        >
          Termo de Compromisso (Anexo I do{' '}
          <a
            href="https://drive.google.com/file/d/1g-S0_N6D9TCma0UHMhWJ-IAv0H54sKgY/view"
            target="_blank"
            rel="noopener noreferrer"
          >
            Edital
          </a>{' '}
          de Seleção *
        </Typography>
        <Box
          component="span"
          className={classes.help}
          data-tip="Anexe o termo de compromisso <br /> preenchido e assinado"
        >
          ?
        </Box>
      </FieldFile>
      <FieldFile name="FileDocCourse" required>
        <Typography
          component="label"
          htmlFor="FileDocCourse"
          className={classes.label}
        >
          Comprovante de Conclusão de Curso *
        </Typography>
        <Box
          component="span"
          className={classes.help}
          data-tip="Anexe o comprovante de <br /> conclusão do curso superior ou <br /> outro comprovante que o substitua"
        >
          ?
        </Box>
      </FieldFile>
      <FieldFile name="FileDocUFC">
        <Typography
          component="label"
          htmlFor="FileDocUFC"
          className={classes.label}
        >
          Comprovante de Vínculo com a UFC
        </Typography>
        <Box
          component="span"
          className={classes.help}
          data-tip="Caso seja um colaborador da <br /> Universidade Federal do Ceará, <br /> anexe um comprovante <br /> de vínculo com a Instituição"
        >
          ?
        </Box>
        <Typography variant="body2" className={classes.description}>
          Esse documento se aplica para servidores da Universidade que estejam
          pleiteando a vaga.
        </Typography>
      </FieldFile>
      <FieldFile name="FileDocBarema" required>
        <Typography
          component="label"
          htmlFor="FileDocBarema"
          className={classes.label}
        >
          Barema Curricular (Anexo II do{' '}
          <a
            href="https://drive.google.com/file/d/1g-S0_N6D9TCma0UHMhWJ-IAv0H54sKgY/view"
            target="_blank"
            rel="noopener noreferrer"
          >
            Edital
          </a>{' '}
          de Seleção *
        </Typography>
        <Box
          component="span"
          className={classes.help}
          data-tip="Anexe o barema curricular e os <br /> documentos comprobatórios <br /> em um único arquivo pdf"
        >
          ?
        </Box>
      </FieldFile>
      <FieldFile name="FileDocLetter" required>
        <Typography
          component="label"
          htmlFor="FileDocLetter"
          className={classes.label}
        >
          Carta de Motivação *
        </Typography>
        <Box
          component="span"
          className={classes.help}
          data-tip="Anexe um pdf de no máximo <br /> uma página contendo <br /> a carta de motivação"
        >
          ?
        </Box>
      </FieldFile>
      <ReactTooltip event="click" multiline />
    </>
  )
}

export default SendFileForm
